import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import SportsTennisOutlined from "@mui/icons-material/SportsTennisOutlined";
import BookingRow from "./BookingRow";

function DaySection({ title, bookings, onMark, onNote }) {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent sx={{ p: { xs: 1.75, sm: 3 }, "&:last-child": { pb: { xs: 1.75, sm: 3 } } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <SportsTennisOutlined fontSize="small" color="primary" />
          <Typography variant="h6" fontWeight={600}>
            {title}
          </Typography>
          <Chip size="small" color="primary" label={bookings.length} sx={{ ml: "auto", fontWeight: 700 }} />
        </Box>
        {bookings.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
            No bookings.
          </Typography>
        ) : (
          bookings.map((b, i) => (
            <React.Fragment key={b._id}>
              {i > 0 && <Divider />}
              <BookingRow booking={b} onMark={onMark} onNote={onNote} />
            </React.Fragment>
          ))
        )}
      </CardContent>
    </Card>
  );
}

export default DaySection;
